import {Injectable} from '@angular/core';
import {ParentService} from "./ParentService";
import {ExamEntity} from "../model/ExamEntity";
import {Shared} from "../view/shared/shared";
import {EstimationSettingsEntity} from "../model/EstimationSettingEntity";

@Injectable()
export class ExamService extends ParentService{

  public getExams(){
    return this.http.get<ExamEntity[]>(this.shared.MAGNAMENT_URL+'/getExams');
  }

  public saveExam(exam: ExamEntity){
    return this.http.post<ExamEntity>(this.shared.MAGNAMENT_URL+'/saveExam', exam);
  }

  public getEstimationSettings(examId){
    return this.http.get<EstimationSettingsEntity[]>(this.shared.MAGNAMENT_URL+'/getEstimationSettings/'+examId);
  }

  public getPosition(examId, score, exp, mu, sigma, population, realpopulation, handicap, peak){
    return this.http.get<number>(this.shared.MAGNAMENT_URL+'/getEstimation/'+examId+'/'+score+'/'+exp+'/'+mu+'/'+sigma+'/'+population+'/'+realpopulation+'/'+handicap+'/'+peak);
  }

  public getPositionByYear(corpId, examId, score, callYear, mu, sigma, population, realpopulation, handicap, peak){
    return this.http.get<number>(this.shared.MAGNAMENT_URL+'/getEstimationByYear/'+corpId+'/'+examId+'/'+score+'/'+callYear+'/'+mu+'/'+sigma+'/'+population+'/'+realpopulation+'/'+handicap+'/'+peak);
  }

  public getOtherYears(year, category){
    return this.http.get<number[]>(this.shared.MAGNAMENT_URL+'/getOtherYears/'+year+'/'+category);
  }

  public getMedian(year, corpId){
    return this.http.get<number>(this.shared.MAGNAMENT_URL+'/getMedian/'+year+'/'+corpId);
  }

  public getMode(year, corpId){
    return this.http.get<number>(this.shared.MAGNAMENT_URL+'/getMode/'+year+'/'+corpId);
  }

  public getHistogram(mu, sigma, population){
    return this.http.get<number[]>(this.shared.MAGNAMENT_URL+'/getHistogram/'+mu+'/'+sigma+'/'+population);
  }

  public saveEstimation(estimation: EstimationSettingsEntity){
    return this.http.post<EstimationSettingsEntity>(this.shared.MAGNAMENT_URL+'/saveEstimation', estimation);
  }

  public reCorrectExams(examId){
    return this.http.get<boolean>(this.shared.MAGNAMENT_URL+'/recorrectExams/'+examId);
  }

  public reEstimateExams(examId){
    return this.http.get<boolean>(this.shared.MAGNAMENT_URL+'/reestimateExams/'+examId);
  }

  public getExamAssociated(examAssociated: number) {
    return this.http.get<ExamEntity>(this.shared.MAGNAMENT_URL+'/getExamAssociated/'+examAssociated)
  }
}
